import { useCallback } from 'react';

export const useFileSelector = () => {
  const selectFile = useCallback(({ fileType, multiple = false }: { fileType: string; multiple?: boolean }) => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = fileType;
    input.multiple = multiple;

    return new Promise<File[]>((resolve, reject) => {
      input.onchange = (event: Event) => {
        const target = event.target as HTMLInputElement;

        if (!target.files) {
          reject(new Error('No file selected'));
          return;
        }

        resolve(Array.from(target.files));
      };

      input.click();
    });
  }, []);

  const selectImage = useCallback(() => selectFile({ fileType: 'image/png,image/jpeg,image/jpg' }), [selectFile]);
  const selectDeliverables = useCallback(
    () => selectFile({ fileType: '.epub,.mobi,.pdf,.jpg,.csv,.docx,.jpeg', multiple: true }),
    [selectFile]
  );

  return { selectImage, selectDeliverables };
};
